import { Controller } from "@hotwired/stimulus"

// Rich text editor controller using contenteditable
export default class extends Controller {
  static targets = ["input", "editor", "toolbar"]

  connect() {
    // Sync initial content
    if (this.hasEditorTarget && this.hasInputTarget) {
      this.editorTarget.innerHTML = this.inputTarget.value || ""
    }
  }

  update() {
    if (this.hasInputTarget && this.hasEditorTarget) {
      this.inputTarget.value = this.editorTarget.innerHTML
    }
  }

  bold(event) {
    event.preventDefault()
    document.execCommand("bold", false, null)
    this.update()
  }

  italic(event) {
    event.preventDefault()
    document.execCommand("italic", false, null)
    this.update()
  }

  link(event) {
    event.preventDefault()
    const url = prompt("Enter URL:")
    if (url) {
      document.execCommand("createLink", false, url)
      this.update()
    }
  }

  unorderedList(event) {
    event.preventDefault()
    document.execCommand("insertUnorderedList", false, null)
    this.update()
  }

  orderedList(event) {
    event.preventDefault()
    document.execCommand("insertOrderedList", false, null)
    this.update()
  }
}
